import { isDevelopment } from 'util/env';

export const FEATHER_DOMAIN = isDevelopment
  ? undefined
  : '.feather-insurance.com'; // TODO: get value from private-constants

export const FEATHER_INTERNAL_TRACKING_TOOL = '_fitt';
